/* eslint-disable prettier/prettier */
import axios from "@/utils/request"

// 获取购物车数据params
export function getCart() {
  return axios({
    url: "/distribution/cart",
    method: "GET"
  })
}
// 购物车详情列表
export function getCartItem(params) {
  return axios({
    url: "/distribution/cartItem",
    method: "GET",
    params
  })
}
// 删除购物车详情
export function deCartItem(id) {
  return axios({
    url: '/distribution/cartItem/' + id,
    method: 'DELETE'
  })
}

// 获取购物车项可选物流
export function getLogistics(params) {
  return axios({
    url: '/distribution/cartItem/logistics',
    method: 'GET',
    params
  })
}
// 生成订单
export function createOrder(data) {
  return axios({
    url: '/distribution/cartItem/createOrder',
    method: 'POST',
    data
  })
}
// 获取地址列表
export function getAddressList(params) {
  return axios({
    url: '/distribution/userAddress',
    method: 'GET',
    params
  })
}
// 获取上们门自提列表
export function getPickUpList(params) {
  return axios({
    url: '/distribution/logisticsPickUpAddress',
    method: 'GET',
    params
  })
}